export default {
  Codigo: null,
  Descripcion: '',
  ClaveInterna: null,
  Activo: true,
};
